[
  {
    "inputs": [
      {
        "internalType": "uint16[]",
        "name": "punkIds",
        "type": "uint16[]"
      }
    ],
    "name": "unwrap",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "caller",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint16[]",
        "name": "punkIds",
        "type": "uint16[]"
      }
    ],
    "name": "PunksUnwrapped",
    "type": "event"
  }
]
